<div class="indicator-wrapper"
    [popper]="tooltipcontent"
    popperTrigger="hover"
    [popperPlacement]="position"
    [popperPositionFixed]="true"
    popperAppendTo="app-root"
    [popperHideOnMouseLeave]="true"
    [popperDisabled]="!showPopper">
  <div class="indicator-container">
    <span class="status-circle" *ngFor="let status of [].constructor(range); let i = index"></span>
  </div>
  <span class="indicator-text mt4" *ngIf="text">
  {{text | translate}}
  </span>
</div>

<popper-content #tooltipcontent stop-propagation>
  <div *ngIf="date" class="text-grey-100 font-text text-sm">
    {{text}} {{date | formDate}}
  </div>
  <div *ngIf="description">
    {{ description | translate}}
  </div>
  <div *ngIf="template" [innerHTML]="template"></div>
</popper-content>

